import { __decorate, __metadata } from 'tslib';
import { Input, Component, ViewContainerRef, Directive, NgModule } from '@angular/core';
import qrcode from 'qrcode';
import { CommonModule } from '@angular/common';

var QrCodeComponent = /** @class */ (function () {
    function QrCodeComponent() {
    }
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], QrCodeComponent.prototype, "value", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], QrCodeComponent.prototype, "size", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], QrCodeComponent.prototype, "errorCorrectionLevel", void 0);
    QrCodeComponent = __decorate([
        Component({
            selector: "qr-code",
            template: "\n    <canvas *ngIf=\"value\"\n            [qrCode]=\"value\"\n            [qrCodeErrorCorrectionLevel]=\"errorCorrectionLevel\"\n            [width]=\"size\" [height]=\"size\">\n    </canvas>\n  "
        })
    ], QrCodeComponent);
    return QrCodeComponent;
}());

var QrCodeDirective = /** @class */ (function () {
    function QrCodeDirective(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
        // tslint:disable-next-line:no-input-rename
        this.errorCorrectionLevel = "M";
    }
    QrCodeDirective.prototype.ngOnChanges = function () {
        if (!this.value) {
            return;
        }
        if (this.version && this.version > 40) {
            console.warn("[qrCode] max version is 40, clamping");
            this.version = 40;
        }
        else if (this.version && this.version < 1) {
            console.warn("[qrCode] min version is 1, clamping");
            this.version = 1;
        }
        else if (this.version !== undefined && isNaN(this.version)) {
            console.warn("[qrCode] version should be set to a number, defaulting to auto");
            this.version = undefined;
        }
        var canvas = this.viewContainerRef.element.nativeElement;
        if (!canvas) {
            // native element not available on server side rendering
            return;
        }
        var context = canvas.getContext("2d");
        if (context) {
            context.clearRect(0, 0, context.canvas.width, context.canvas.height);
        }
        // tslint:disable-next-line:no-floating-promises
        qrcode
            .toCanvas(canvas, this.value, {
            version: this.version,
            errorCorrectionLevel: this.errorCorrectionLevel,
            width: this.width,
        });
    };
    QrCodeDirective.ctorParameters = function () { return [
        { type: ViewContainerRef }
    ]; };
    __decorate([
        Input("qrCode"),
        __metadata("design:type", String)
    ], QrCodeDirective.prototype, "value", void 0);
    __decorate([
        Input("qrCodeVersion"),
        __metadata("design:type", Number)
    ], QrCodeDirective.prototype, "version", void 0);
    __decorate([
        Input("qrCodeErrorCorrectionLevel"),
        __metadata("design:type", String)
    ], QrCodeDirective.prototype, "errorCorrectionLevel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], QrCodeDirective.prototype, "width", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], QrCodeDirective.prototype, "height", void 0);
    QrCodeDirective = __decorate([
        Directive({
            // tslint:disable-next-line:directive-selector
            selector: "canvas[qrCode]",
        }),
        __metadata("design:paramtypes", [ViewContainerRef])
    ], QrCodeDirective);
    return QrCodeDirective;
}());

var QrCodeModule = /** @class */ (function () {
    function QrCodeModule() {
    }
    QrCodeModule = __decorate([
        NgModule({
            declarations: [
                QrCodeComponent,
                QrCodeDirective,
            ],
            imports: [
                CommonModule,
            ],
            exports: [
                QrCodeComponent,
                QrCodeDirective,
            ],
        })
    ], QrCodeModule);
    return QrCodeModule;
}());

/*
 * Public API Surface of ng-qrcode
 */

/**
 * Generated bundle index. Do not edit.
 */

export { QrCodeComponent, QrCodeDirective, QrCodeModule };
//# sourceMappingURL=ng-qrcode.js.map
